export default __webpack_public_path__ + "static/media/6.31b1b5d4.mp3";